<template>

  <div class="position-relative">
    <img :alt="$t('loading')" :src="loadingUrl" v-if="isImageLoading" style="position: absolute; top: 10px; left: 10px; z-index: 100">
    <button type="button" v-if="showResetZoom" @click="resetZoom()" style="position: absolute; top:10px; right: 10px; z-index: 100" class="button p5 w100">{{ $t('reset_zoom') }}</button>

    <pinch-zoom ref="pz" style="position: relative;" :limitPan="true" disableZoomControl="disable" limitZoom="5" backgroundColor="rgba(255,255,255,1)">
      <img :src="currentImage" @load="isImageLoading=false" crossOrigin="anonymous" ref="imgproduct" class="position-relative img-fluid" @mouseleave="imgMouseLeave" @mousemove="imgMouseMove" @mouseout="imgMouseOut" />
      <template v-if="showOkresy">
        <img :src="okresyImage" @click="showModal()" style="z-index: 100"  crossOrigin="anonymous" draggable="false" ref="refOkresy" class="position-absolute img-fluid" @mouseleave="imgMouseLeave" @mousemove="imgMouseMove" @mouseout="imgMouseOut" />
      </template>
      <canvas style="display: none" ref="cs"></canvas>
      <canvas style="position: absolute;" ref="cs_p"></canvas>
      <div class="tooltipx" ref="ttip" :style="ttipStyle">{{ ttipVal }}</div>
    </pinch-zoom>


  </div>

</template>

<script>

import PinchZoom from 'vue-pinch-zoom';
import _ from 'lodash';
import SHMUconf from "../../shmu_conf";
import VModal from 'vue-js-modal'
import GraphModalComponent from "./GraphModalComponent.vue";


export default {
  components: {
    'pinch-zoom': PinchZoom,
  },
  name: 'ImgPZCTComponent',
  props: {
    colors: Array,
    districts: Array,
    currentImage: String,
    showOkresy: Boolean,
    selectedProductData: Object,
  },
  data() {
    return {
      loadingUrl: SHMUconf.SITE_BASE_URL + 'img/loader.gif',
      okresyImage: SHMUconf.SITE_BASE_URL + 'data/dataklima/meta/okresne_mesta_t2.png',
      showResetZoom: false,
      pinchZoomScale: 0,
      isImageLoading: false,
      ttipStyle: {},
      ttipVal: '',
      productNotFound: false,
      imgInCanvas: null,
      canvasData: null,
      rzInterval:0,
      hoveredOkres: null
    }
  },
  mounted() {
    this.rzInterval = setInterval(() => {
      if(this.$refs.pz){
        this.pinchZoomScale = this.$refs.pz.getScale();
      }
    }, 100);
  },
  destroy() {
    clearInterval(this.rzInterval);
  },
  watch: {
    currentImage(val) {
      this.isImageLoading = true;
    },
    pinchZoomScale(v) {
      this.showResetZoom = v > 1;
    }
  },
  computed: {
    isJsonAvail() {
      return this.selectedProductData.subory_json.length > 0;
    }

  },
  methods: {
    resetZoom() {
      if (this.$refs.pz.getScale() > 1) {
        this.showResetZoom = false;
        this.$refs.pz.toggleZoom();
      }
    },
    imgMouseMove: _.throttle(function (e) {

      const self = this;

      let colors = self.colors;
      if (!colors) return;
      if (this.isImageLoading) return;

      let x, y;
      if (e.offsetX) {
        x = e.offsetX;
        y = e.offsetY;
      } else if (e.layerX) {
        x = e.layerX;
        y = e.layerY;
      }
      let canvas = this.$refs['cs'];
      let canvas_p = this.$refs['cs_p'];
      let img = this.$refs['imgproduct'];
      let pz = this.$refs['pz'];

      let short_koef = img.naturalWidth / img.width / 0.938;

      if (this.imgInCanvas !== this.currentImage) {
        this.applyImageToCanvas(canvas, img);
        this.imgInCanvas = this.currentImage;
        this.canvasData = canvas.getContext('2d', {willReadFrequently: true}).getImageData(0, 0, canvas.width, canvas.height);

        // POINT DEBUG
        /*
        this.applyImageToCanvas(canvas_p, img);
        let ctx = canvas_p.getContext('2d');
        this.districts.forEach((district) => {

          let x2 = Math.round(parseInt(district.x2) / short_koef);
          let y2 = img.height - Math.round(parseInt(district.y2) / short_koef) - 20;

          ctx.beginPath();
          ctx.arc(x2, y2, 12, 0, 2 * Math.PI);
          ctx.fillStyle = "red";
          ctx.fill();
          ctx.lineWidth = 1;
          ctx.strokeStyle = "blue";
          ctx.stroke();

        })

         */

      }

      let add_x_offset = Math.round((pz.$el.clientWidth - img.clientWidth) / 2);

      let c_x = Math.round(x*short_koef);
      let c_y = Math.round(y*short_koef);

      let c_pos_x = c_x;
      let c_pos_y = img.naturalHeight - c_y;

      if (this.isJsonAvail && this.showOkresy) {
        this.hoveredOkres = this.getDistrictByXY(c_pos_x, c_pos_y, 12);
        if (this.hoveredOkres) {
          document.getElementsByTagName("body")[0].style.cursor = "pointer";
        } else {
          document.getElementsByTagName("body")[0].style.cursor = "default";
        }
      }
      // console.log(c_pos_x, c_pos_y, okres);

      let px = Math.round((x * 100) / img.clientWidth);
      let py = Math.round((y * 100) / img.clientHeight);

      let nove_x = x + add_x_offset;

      // console.log(pz.$el.clientWidth, img.clientWidth, x, nove_x, y);

      self.$refs['ttip'].style.left = (nove_x + 5) + 'px';
      self.$refs['ttip'].style.top = (y - 20) + 'px';
      self.$refs['ttip'].style.display = 'block';

      // let p = canvas.getContext('2d').getImageData(x, y, 1, 1).data;
      let index = (y * this.canvasData.width + x) * 4;

      let p = [];
      p.push(this.canvasData.data[index]);
      p.push(this.canvasData.data[index + 1]);
      p.push(this.canvasData.data[index + 2]);
      p.push(this.canvasData.data[index + 3]);

      // show preview color
      if (p) {
        //self.ttipVal = self.rgbToHex(p[0], p[1], p[2]);
        let hex_color = self.rgbToHex(p[0], p[1], p[2]);
        let color_type = 'ALL';
        /*
      if (self.current_product_meta.color_type === 'all') color_type = 'ALL'; // ak budu vynimky pre jednotlive produkty, potom dorobime
      else {
        if (px >= 50 && py <= 50) color_type = 'ROZPTYL';
        else color_type = 'PRIEMER';
      }
      */

        //console.log(color_type)

        let skala = colors.filter(item => item.type === color_type);

        let naslo_sa = skala.find(item => this.isNeighborColor(this.hexToRgb(item.hex_color), this.hexToRgb(hex_color), 3));

        if (naslo_sa) {
          // self.$refs['ttip'].innerHTML = naslo_sa.display + ' ' + hex_color;
          self.$refs['ttip'].innerHTML = naslo_sa.display;
          self.$refs['ttip'].style.display = 'block';
        } else {
          // self.$refs['ttip'].style.display = 'block';
          // self.$refs['ttip'].innerHTML = hex_color;
          self.$refs['ttip'].style.display = 'none';
        }


      }

    }, 50),
    imgMouseLeave: _.debounce(function () {
      // console.log('heh')
      this.$refs['ttip'].style.display = 'none';

    }, 500),
    imgMouseOut(e) {

    },
    applyImageToCanvas(el, image) {
      el.width = image.width; // img width
      el.height = image.height; // img height
      // draw image in canvas tag
      el.getContext('2d', {willReadFrequently: true}).drawImage(image, 0, 0, image.width, image.height);
    },
    componentToHex(c) {
      if (c) {
        let hex = c.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
      }
      return "00";
    },
    rgbToHex(r, g, b) {
      return this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
    },
    hexToRgb(hex) {
      let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    },
    isNeighborColor(color1, color2, tolerance) {
      if (tolerance === undefined) {
        tolerance = 10;
      }

      // console.log(color1, color2);

      return Math.abs(color1.r - color2.r) <= tolerance
          && Math.abs(color1.g - color2.g) <= tolerance
          && Math.abs(color1.b - color2.b) <= tolerance;
    },
    getDistrictByXY(x,y, tolerance) {
      for (let i = 0; i < this.districts.length; i++) {
        let x2 = parseInt(this.districts[i].x2);
        let y2 = parseInt(this.districts[i].y2) - 25;
        let code = this.districts[i].code;

        let x_ok = false;
        let y_ok = false;
        /*
        if (code == "BA") {
          console.log(x, y, Math.abs(x - x2), Math.abs(y - y2), tolerance);
        }
         */
        if (Math.abs(x - x2) <= tolerance) x_ok = true;
        if (Math.abs(y - y2) <= tolerance) y_ok = true;
        if (x_ok && y_ok) {
          return code;
        }

      }
      return null;
    },
    showModal() {

      let okres = this.hoveredOkres;
      if (!okres) return;

      let json_file = null;
      this.selectedProductData.subory_json.find(item => {
          if (item.startsWith(okres)) {
            json_file = item;
            return true;
          }
      });

      if (json_file === null) return;

      json_file = SHMUconf.SITE_BASE_URL + 'data/dataklima/maps/' + this.selectedProductData.dir_date + '/' + this.selectedProductData.json_dir + '/' + json_file;
      this.$modal.show(GraphModalComponent, {
            okres: okres,
            json_url: json_file,
            produkt: this.selectedProductData.produkt,
          },
          {
            draggable: false, width: '1200px', height: 'auto', resizable: true
          }, {
            'before-close': this.beforeModalClose
          }
      );
    },
    beforeModalClose() {
      this.hoveredOkres = null;
      document.getElementsByTagName("body")[0].style.cursor = "default";
    }

  }

}
</script>